
<div
  :class="
    classes(
      n(),
      n(`theme--${theme}`),
    )
  "
>
  <!-- 左侧区域：返回控件 -->
  <div
    v-if="showBackControl"
    :class="n('back-button')"
    :aria-label="backText"
    @click="handleBack"
  >
    <slot
      v-if="$slots['back-icon']"
      :class="n('back-button-icon')"
      name="back-icon"
    />
    <component
      :is="backIcon"
      v-else
      width="24"
      height="48"
      :class="n('back-button-icon')"
      @click="handleBack"
    />
  </div>

  <!-- 搜索输入区域 -->
  <div :class="n('input')">
    <!-- 左侧图标 -->
    <div :class="n('input-left')" @click="handleLeftIconClick">
      <slot
        v-if="$slots['left-icon']"
        name="left-icon"
        :class="n('input-left-icon')"
      />
      <component
        :is="leftIcon"
        v-else
        :class="n('input-left-icon')"
        @click="handleLeftIconClick"
      />
    </div>

    <!-- 输入容器 -->
    <input
      ref="inputRef"
      :class="classes(n('input-inner'))"
      type="search"
      :cursor-color="cursorColor"
      :placeholder-class="n('input-inner-placeholder')"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :value="inputValue"
      :aria-label="placeholder"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="handleInput"
      @confirm="handleConfirm"
    >

    <!-- 清除按钮：用 v-show 避免 input 时实例化图标组件导致的掉帧 -->
    <div
      v-show="showClear"
      :class="n('input-clear')"
      role="button"
      :aria-label="clearText"
      @click="handleClear"
    >
      <CloseCircleIcon :class="n('input-clear-icon')" />
    </div>

    <!-- placeholder 浮层：独立覆盖在输入区域上方，点击即聚焦输入框 -->
    <div
      v-if="isPlaceholderVisible"
      :class="n('input-placeholder-overlay')"
      @click="handleOverlayClick"
    >
      <div :class="n('input-placeholder-overlay-left')">
        <slot
          v-if="$slots['left-icon']"
          name="left-icon"
          :class="n('input-placeholder-overlay-left-icon')"
        />
        <component
          :is="leftIcon"
          v-else
          :class="n('input-placeholder-overlay-left-icon')"
        />
      </div>
      <span :class="n('input-placeholder-overlay-text')">{{ placeholder }}</span>
    </div>
  </div>

  <!-- 右侧操作区 -->
  <div
    v-if="isFocused"
    :class="n('action')"
  >
    <slot
      v-if="$slots.action"
      name="action"
    />
    <div
      v-else
      :class="n('cancel')"
      role="button"
      :aria-label="cancelText"
      @click="handleCancel"
    >
      {{ cancelText }}
    </div>
  </div>
</div>
